// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");
var Belt_SetString = require("bs-platform/lib/js/belt_SetString.js");
var Errors$XodFuncTools = require("xod-func-tools/src/Errors.bs.js");
var SpecialColumns$XodTabtest = require("./SpecialColumns.bs.js");

function validatePinLabels(realPinLabels, testingPinLabels) {
  var testingPinLabelsSet = Belt_SetString.fromArray(Belt_List.toArray(testingPinLabels));
  var realPinLabelsSet = Belt_SetString.fromArray(Belt_List.toArray(realPinLabels));
  var missingPinLabels = Belt_SetString.toList(Belt_SetString.diff(realPinLabelsSet, testingPinLabelsSet));
  var redundantPinLabels = Belt_List.keep(Belt_SetString.toList(Belt_SetString.diff(testingPinLabelsSet, realPinLabelsSet)), (function (param) {
          return SpecialColumns$XodTabtest.time !== param;
        }));
  var duplicatedPinLabels = Belt_List.keep(Belt_List.fromArray(Belt_MapString.keysToArray(Belt_MapString.keep(Belt_List.reduce(testingPinLabels, Belt_MapString.empty, (function (acc, pinLabel) {
                          var pinLabelCount = Belt_MapString.getWithDefault(acc, pinLabel, 0);
                          return Belt_MapString.set(acc, pinLabel, pinLabelCount + 1 | 0);
                        })), (function (param, v) {
                      return v > 1;
                    })))), (function (x) {
          return !Belt_List.has(redundantPinLabels, x, (function (prim, prim$1) {
                        return prim === prim$1;
                      }));
        }));
  var errorOccured = ((Belt_List.length(missingPinLabels) + Belt_List.length(redundantPinLabels) | 0) + Belt_List.length(duplicatedPinLabels) | 0) > 0;
  if (errorOccured) {
    var payload = {
      missing: Belt_List.toArray(missingPinLabels),
      redundant: Belt_List.toArray(redundantPinLabels),
      duplicated: Belt_List.toArray(duplicatedPinLabels)
    };
    return Caml_option.some(Errors$XodFuncTools.createError("INVALID_PIN_LABELS_IN_TABTEST", payload));
  }
  
}

exports.validatePinLabels = validatePinLabels;
/* Errors-XodFuncTools Not a pure module */



//////////////////
// WEBPACK FOOTER
// ../xod-tabtest/src/Validator.bs.js
// module id = 1481
// module chunks = 0